import React, { useState, useCallback } from 'react';
import { Plus } from 'lucide-react';
import AdminLayout from '@/components/Admin/Layout/AdminLayout';
import SettingsLayout from '@/components/Admin/Settings/SettingsLayout';
import IntegrationMessages from '@/components/Admin/Settings/Integration_Setting/IntegrationMessages';

export default function IntegrationManagementPage() {
  const [componentActions, setComponentActions] = useState(null);

  const handleActionsReady = useCallback((actions) => {
    setComponentActions(actions);
  }, []);

  // Action buttons for the header - changes based on selected tab
  const headerActions = componentActions ? (
    componentActions.selectedTab === "sms" ? (
      <button
        onClick={componentActions.onAddTemplate}
        className="px-3 py-1.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium"
      >
        <Plus size={16} />
        Add Template
      </button>
    ) : (
      <button
        onClick={componentActions.onAddProvider}
        className="px-3 py-1.5 bg-teal-600 text-white rounded-lg hover:bg-teal-700 flex items-center gap-1.5 text-sm font-medium"
      >
        <Plus size={16} />
        Add Provider
      </button>
    )
  ) : null;

  return (
    <AdminLayout>
      <SettingsLayout actions={headerActions}>
        <IntegrationMessages renderActions={handleActionsReady} />
      </SettingsLayout>
    </AdminLayout>
  );
}
